import { BaseEventProps } from "../../types";

export type EventProps = BaseEventProps;

export enum MediatorEventType {
  LOGOUT_BUTTON_CLICKED = "LOGOUT_BUTTON_CLICKED",
  LOGOUT_PROCESS_INITIATED = "LOGOUT_PROCESS_INITIATED"
}

export interface EventData {
  type: MediatorEventType;
  payload: {
    loggedOutBy?: string;
  };
}

export interface LogoutProcessInitiatedEventProps {
  loggedOutBy?: string;
}
